interface CheckCircleIconProps {
  size?: number;
  className?: string;
}

/**
 * Zelený check v kolečku pro stav „splněno". Kreslí se přes currentColor
 * (obarvení řídí CSS podle kontextu), proto nejde použít asset checkmark-circle.svg
 * s napevno danou teal barvou.
 */
export const CheckCircleIcon: React.FC<CheckCircleIconProps> = ({ size = 24, className }) => (
  <svg className={className} viewBox="0 0 24 24" width={size} height={size} fill="none" aria-hidden="true">
    <circle cx="12" cy="12" r="10" fill="currentColor" />
    <path d="M8 12.4l2.6 2.6 5-5.4" stroke="#fff" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
  </svg>
);

export default CheckCircleIcon;
